<template>
    <Link :href="route('advisors.suppliers.show', supplier.uuid)" preserve-state class="block">
        <div class="py-2 px-2 my-2 border border-gray-200 flex w-full hover:bg-gray-100">
            <div class="p-1 w-5/6 md:w-3/6">{{ supplier.name }}</div>
            <div class="hidden md:block p-1 w-2/6 text-minplan-grey">{{ supplier.zip }} {{ supplier.city }}</div>
            <div class="p-1 w-1/6 md:w-1/6"><SearchIcon class="h-5 w-5 float-right text-minplan-grey" aria-hidden="true" /></div>
        </div>
    </Link>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue3";
import { SearchIcon } from "@heroicons/vue/outline";

export default {
    props: ["supplier"],
    components: { Link, SearchIcon }
};
</script>

<style scoped></style>
